import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { loadDepartmentDropdownData, loadReportingDesignationDropdownData, loadSingleDesignationData, postDesignationDatas, postDynamicDashboardDatas } from "../../../redux/action";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch, useSelector } from "react-redux";
import { ADDED_BY_ID } from "../../../Constants";
import attachmentImg from '../../../assets/images/attachmentImg.svg';
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AddDynamicDashboards = (props) => {

    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

    const getDynamicDashboardCategoryDropdownData = props.getDynamicDashboardCategoryDropdownData;
    const getCompanyDropdown = props.getCompanyDropdown;
    const getSingleDynamicDashboardData = props.getSingleDynamicDashboardData;
    const assignedModulesDropdown = props.assignedModulesDropdown;
    const dashboardId = props.dashboardId;
    const companyId = signInDetails?.[0]?.CompanyID || null;
    const dataLoading = props.dataLoading;
    // console.log(getDynamicDashboardCategoryDropdownData, 'getDynamicDashboardCategoryDropdownData')

    const [selectedFile, setSelectedFile] = useState(null);

    const [errors, setErrors] = useState({});

    const [dynamicDashboardData, setDynamicDashboardData] = useState({
        CompanyID: companyId,
        DashboardLibraryName: "",
        DashboardCategoryID: null,
        SecuredLink: "",
        PublicLink: "",
        Description: "",
        FileName: "",
        AddedByID: ADDED_BY_ID,
        StatusID: null,
        File: null,
        ModuleID: null,
        DisplaySecuredLink: false,
        DisplayPublicLink: false,
    });
    const [imgChange, setImgChange] = useState(false);

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setDynamicDashboardData(prevData => ({
    //         ...prevData,
    //         [name]: value
    //     }));
    //     setErrors(prevErrors => ({ ...prevErrors, [name]: "" })); // Clear error on change
    // };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setDynamicDashboardData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Remove error message when user starts typing
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: value.trim() ? "" : prevErrors[name],
        }));
    };

    const handleSelectChange = (selectedOption, action) => {
        setDynamicDashboardData(prevData => ({
            ...prevData,
            [action.name]: selectedOption ? selectedOption.value : null // Store only the value
        }));
        setErrors(prevErrors => ({ ...prevErrors, [action.name]: "" }));
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setSelectedFile(file);
                const base64Data = reader.result.split(',')[1];  // Extract actual Base64 data part
                setDynamicDashboardData(prevData => ({
                    ...prevData,
                    File: base64Data, // Store only the Base64 content (without metadata)
                    FileName: file.name
                }));
                setImgChange(true);
            };
            reader.onerror = (error) => {
                console.error("Error converting file to Base64:", error);
            };
        }
    };

    // const handleCheckboxChange = (e) => {
    //     const { name, checked } = e.target;
    //     setCheckboxes(prev => ({ ...prev, [name]: checked }));
    // };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setDynamicDashboardData(prev => ({
            ...prev,
            [name]: checked,  // Toggle checkbox value
            [name === "DisplaySecuredLink" ? "SecuredLink" : "PublicLink"]: checked ? prev[name === "DisplaySecuredLink" ? "SecuredLink" : "PublicLink"] : "",  // Clear value if unchecked
        }));

        setErrors(prevErrors => ({
            ...prevErrors,
            [name === "DisplaySecuredLink" ? "SecuredLink" : "PublicLink"]: checked ? (dynamicDashboardData[name === "DisplaySecuredLink" ? "SecuredLink" : "PublicLink"] ? "" : "This field is required") : "",  // Validate only if checked
        }));
    };

    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };

    useEffect(() => {
        if (dashboardId && getSingleDynamicDashboardData?.length > 0) {
            const dashboardData = getSingleDynamicDashboardData[0]; // Get the first object from array
            const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

            setDynamicDashboardData({
                // CompanyID: dashboardData.CompanyID || null,
                CompanyID: signInDetails?.[0]?.CompanyID || null,
                DashboardLibraryID: dashboardId || null,
                DashboardLibraryName: dashboardData.DashboardLibraryName || "",
                DashboardCategoryID: dashboardData.DashboardCategoryID || null,
                SecuredLink: dashboardData.SecuredLink || "",
                PublicLink: dashboardData.PublicLink || "",
                Description: dashboardData.Description || "",
                FileName: dashboardData.FileName || "",
                AddedByID: ADDED_BY_ID,
                StatusID: dashboardData.StatusID || null,
                File: dashboardData.File,
                IsFileUpdated: false,  // Default to false,
                ModuleID: dashboardData.ModuleID,
                DisplaySecuredLink: dashboardData.DisplaySecuredLink || false,
                DisplayPublicLink: dashboardData.DisplayPublicLink || false,
            });
        } else {
            setDynamicDashboardData({
                CompanyID: null,
                DashboardLibraryID: null,
                DashboardLibraryName: "",
                DashboardCategoryID: null,
                SecuredLink: "",
                PublicLink: "",
                Description: "",
                FileName: "",
                AddedByID: ADDED_BY_ID,
                StatusID: null,
                File: null,
                ModuleID: null
            });
        }
    }, [dashboardId, getSingleDynamicDashboardData]);

    const validateForm = () => {
        let tempErrors = {};
        // if (!dynamicDashboardData.CompanyID) tempErrors.CompanyID = "Company is required";
        if (!dynamicDashboardData.DashboardLibraryName) tempErrors.DashboardLibraryName = "Dashboard Name is required";
        if (!dynamicDashboardData.DashboardCategoryID) tempErrors.DashboardCategoryID = "Category is required";
        if (!dynamicDashboardData.Description) tempErrors.Description = "Description is required";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const addDynamicDashboardData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const updatedDynamicDashboardData = { ...dynamicDashboardData, IsFileUpdated: imgChange, CompanyID: signInDetails?.[0]?.CompanyID ?? null };
            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(updatedDynamicDashboardData),
            };
            dispatch(postDynamicDashboardDatas(requestOption, props.handleCloseModal, props.fetchDynamicDashboards, dashboardId, imgChange, setImgChange,));
            console.log("Submitting Data:", dynamicDashboardData);
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{dashboardId ? "Edit Dashboards" : "Add Dashboards"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Category</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                options={getDynamicDashboardCategoryDropdownData}
                                                placeholder="Select"
                                                name="DashboardCategoryID"
                                                value={getDynamicDashboardCategoryDropdownData.find(option => option.value === dynamicDashboardData.DashboardCategoryID) || null}
                                                onChange={handleSelectChange}
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            />)}
                                    </div>
                                    {errors.DashboardCategoryID && <div className="text-danger">{errors.DashboardCategoryID}</div>}

                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Dashboard Name</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <Form.Control
                                                type="text"
                                                name="DashboardLibraryName"
                                                value={dynamicDashboardData.DashboardLibraryName}
                                                onChange={handleInputChange}
                                            />)}
                                    </div>
                                    {errors.DashboardLibraryName && <div className="text-danger">{errors.DashboardLibraryName}</div>}
                                </Col>
                                {/* <Col md={4}>
                                    <div>
                                        <label>Company</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={getCompanyDropdown}
                                            placeholder="Select"
                                            name="CompanyID"
                                            value={getCompanyDropdown.find(option => option.value === dynamicDashboardData.CompanyID) || null}
                                            onChange={handleSelectChange}
                                        />
                                    </div>
                                    {errors.CompanyID && <div className="text-danger">{errors.CompanyID}</div>}
                                </Col> */}

                                {dynamicDashboardData?.DashboardCategoryID === 1 && (
                                    // Render the Module Dropdown
                                    <Col md={4}>
                                        <div>
                                            <label>Module</label>
                                            {dataLoading ? (
                                                <Skeleton height={38} />
                                            ) : (
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    options={assignedModulesDropdown} // Make sure this variable holds the module options
                                                    placeholder="Select"
                                                    name="ModuleID"
                                                    value={assignedModulesDropdown.find(option => option.value === dynamicDashboardData.ModuleID) || null}
                                                    onChange={handleSelectChange}
                                                    menuPosition="fixed"
                                                    menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                                />)}
                                        </div>
                                        {/* {errors.ModuleID && <div className="text-danger">{errors.ModuleID}</div>} */}
                                    </Col>
                                )}
                            </Row>
                            <Row>
                                {dynamicDashboardData?.DashboardCategoryID !== 1 && <Col md={12}>
                                    <div>
                                        <label>Secured Link</label>
                                        <div className="d-flex align-items-center">
                                            <Form.Check
                                                type="checkbox"
                                                name="DisplaySecuredLink"
                                                checked={dynamicDashboardData.DisplaySecuredLink}
                                                onChange={handleCheckboxChange}
                                                className="me-2"
                                            />
                                            <Form.Control
                                                type="text"
                                                name="SecuredLink"
                                                value={dynamicDashboardData.SecuredLink}
                                                onChange={handleInputChange}
                                                disabled={!dynamicDashboardData.DisplaySecuredLink}
                                                className={errors.SecuredLink ? "is-invalid" : ""}
                                            />
                                        </div>
                                    </div>
                                    {errors.SecuredLink && <div className="text-danger">{errors.SecuredLink}</div>}
                                </Col>}
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label>Public Link</label>
                                        <div className="d-flex align-items-center">
                                            <Form.Check
                                                type="checkbox"
                                                name="DisplayPublicLink"
                                                checked={dynamicDashboardData.DisplayPublicLink}
                                                onChange={handleCheckboxChange}
                                                className="me-2"
                                            />
                                            <Form.Control
                                                type="text"
                                                name="PublicLink"
                                                value={dynamicDashboardData.PublicLink}
                                                onChange={handleInputChange}
                                                disabled={!dynamicDashboardData.DisplayPublicLink}
                                                className={errors.PublicLink ? "is-invalid" : ""}
                                            />
                                        </div>
                                    </div>
                                    {errors.PublicLink && <div className="text-danger">{errors.PublicLink}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label>Description</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="Description"
                                                value={dynamicDashboardData.Description}
                                                onChange={handleInputChange}
                                            />
                                        )}
                                    </div>
                                    {errors.Description && <div className="text-danger">{errors.Description}</div>}
                                </Col>
                            </Row>
                            <Row>
                                {dashboardId && <Col md={4}>
                                    <div>
                                        <label>Status</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                options={props.enablingOptions}
                                                placeholder="Select"
                                                name="Status"
                                                value={props.enablingOptions.find(option => option.value === dynamicDashboardData.StatusID) || null}
                                                onChange={handleSelectChange}
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            />)}
                                    </div>
                                </Col>}
                                <Col md={5} className="d-flex justify-content-start align-items-end">
                                    <div className="dropdown add-single-bulk attachment-section">
                                        <label></label>
                                        <button
                                            className="btn btn-add-save-update attachment-btn"
                                            id="adduser-single-blulk"
                                            onClick={handleAttachmentClick}
                                        >
                                            <img src={attachmentImg} alt="" />&nbsp;&nbsp;
                                            <span>Attachment</span>
                                            <div className="attachment-note">
                                                <small>(jpg, Png) Less than 5MB</small>
                                            </div>
                                        </button>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleFileChange}
                                        />
                                        {selectedFile && <div className="attachment-note"><small>{selectedFile.name}</small></div>}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={addDynamicDashboardData} />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default AddDynamicDashboards;
